import { Container } from '../components/Container';
import { SectionHeading } from '../components/SectionHeading';
import type { LandingContent } from '../content/types';
import { sectionIds } from '../lib/routes';

type FaqSectionProps = {
  content: LandingContent;
};

export function FaqSection({ content }: FaqSectionProps) {
  return (
    <section className="section" id={sectionIds.faq} aria-labelledby="faq-title">
      <Container size="narrow">
        <SectionHeading id="faq-title" title={content.faq.h2} />
        <div className="faq-list">
          {content.faq.items.map((item) => (
            <details key={item.question}>
              <summary>{item.question}</summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </div>
      </Container>
    </section>
  );
}
